import { defineComponent as _defineComponent } from 'vue'
import HeaderCustomer from "@/components/HeaderCustomer.vue";
  import { computed, onMounted, ref } from "vue";
  import router from "../../router/index";
  import store from "@/store";
  import { isLogged } from "@/features/useUser";
  import LocalStorageService from "@/services/localStorage.service";
  import { changePrimaryColor } from "@/helpers/customer/changePrimaryColor";
  import { EstateInterface } from "@/types/EstateInterface";
  import { changePrimaryColorEoiViews } from "@/helpers/eoi/changePrimaryColorEoiViews";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EOIRequestPaymentConfirmation',
  setup(__props, { expose: __expose }) {
  __expose();

  const estateId = ref(router.currentRoute.value.params.estateId);

  const businessId = computed(() => {
    return (router.currentRoute.value.query?.businessId as string) ?? null;
  });

  const estate = ref<EstateInterface | null>(null);
  const loading = ref(true);

  onMounted(() => {
    LocalStorageService.remove("eoiUserData");
    store
      .dispatch("estate/getEstate", estateId.value)
      .then((res) => {
        estate.value = res.data;
        changePrimaryColorEoiViews(res.data, businessId.value);
      })
      .finally(() => {
        loading.value = false;
      });
  });

  function toDashboard() {
    router.push("/customer/lots");
  }

const __returned__ = { estateId, businessId, estate, loading, toDashboard, HeaderCustomer, computed, onMounted, ref, get router() { return router }, get store() { return store }, get isLogged() { return isLogged }, get LocalStorageService() { return LocalStorageService }, get changePrimaryColor() { return changePrimaryColor }, get EstateInterface() { return EstateInterface }, get changePrimaryColorEoiViews() { return changePrimaryColorEoiViews } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})